
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"29","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.906 9.813h6.75V11.5h1.688V9.812h6.75V11.5h1.687V9.496c0-.738-.633-1.371-1.37-1.371h-7.067v-2.25h1.406c.598 0 1.125-.492 1.125-1.125V1.375c0-.598-.527-1.125-1.125-1.125h-4.5c-.633 0-1.125.527-1.125 1.125V4.75c0 .316.105.598.316.809.211.21.493.316.809.316h1.406v2.25H3.555c-.739 0-1.336.633-1.336 1.371V11.5h1.687V9.812zm5.906-5.626v-2.25h3.376v2.25H9.812zm11.813 8.438H18.25c-.633 0-1.125.527-1.125 1.125v3.375a1.11 1.11 0 001.125 1.125h3.375c.598 0 1.125-.492 1.125-1.125V13.75c0-.598-.527-1.125-1.125-1.125zm-.563 3.938h-2.25v-2.25h2.25v2.25zm-7.875-3.938H9.813c-.633 0-1.126.527-1.126 1.125v3.375a1.11 1.11 0 001.126 1.125h3.374c.598 0 1.126-.492 1.126-1.125V13.75c0-.598-.528-1.125-1.126-1.125zm-.562 3.938h-2.25v-2.25h2.25v2.25zM4.75 12.624H1.375c-.633 0-1.125.527-1.125 1.125v3.375a1.11 1.11 0 001.125 1.125H4.75c.598 0 1.125-.492 1.125-1.125V13.75c0-.598-.527-1.125-1.125-1.125zm-.563 3.938h-2.25v-2.25h2.25v2.25z","fill":"#121131"}})])
          )
        }
      }
    